import { LitElement, html } from 'lit-element';

class SnackBar extends LitElement {

  static get properties() {
    return {
      displayText: {
        type: String,
        attribute: 'display-text'
      },
      displayDuration: {
        type: Number,
        attribute: 'display-duration'
      },
      displayOkButton: {
        type: String,
        attribute: 'display-ok-button'
      },
      displayCloseButton: {
        type: String,
        attribute: 'display-close-button'
      },
      clearPreviousMessage: {
        type: String,
        attribute: 'clear-previous-message'
      },
      animationCss: {
        type: String,
        attribute: 'animation-css'
      },
    };
  }

  constructor(defaultAttributes) {
    super();
    this.displayText = "";
    this.displayDuration = 5000;
    this.displayOkButton = false;
    this.displayCloseButton = false;
    this.isDisplayTextChanged = false;
    this.isDisplayDurationChanged = false;
    this.snackBarMessages = [];
    this.clearPreviousMessage = 'false';
    this.setIntervalVar = null;
    this.animationCss = 'show-from-bottom';
    
    defaultAttributes = defaultAttributes || {};
    Object.keys(defaultAttributes).forEach(function(attrKey){
      if( defaultAttributes[attrKey] != null ) {
        this.setAttribute(attrKey, defaultAttributes[attrKey]);
      }
    }.bind(this));
  }

  connectedCallback() {
    super.connectedCallback();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'display-text':
        this.displayText = newValue || "";
        if( this.displayText ) {
          var displayDuration = ( this.getAttribute("display-duration") )? this.getAttribute("display-duration") * 1000 : this.displayDuration;

          if( this.getAttribute('clear-previous-message') && this.getAttribute('clear-previous-message') == 'true' ) {
            this.snackBarMessages = []; 
            displayDuration = 2000;
            this.requestUpdate('snackBarMessages');
            if( this.setIntervalVar ) {
              window.clearTimeout(this.setIntervalVar);
            }
            this.snackBarMessages[0] = this.displayText;
          } else {
            this.snackBarMessages.push(this.displayText);
          }
          this.setIntervalVar = window.setTimeout(() => {
            this.snackBarMessages.shift();
            this.requestUpdate('snackBarMessages');
          }, (displayDuration));
        }
        break;
      case 'display-duration':
        this.displayDuration = (parseInt(newValue)) ? parseInt(newValue) * 1000 : 5000;
        this.isDisplayDurationChanged = (newValue && oldValue !== newValue);
        break;
      case 'display-ok-button':
        this.displayOkButton = (newValue === "true");
        break;
      case 'display-close-button':
        this.displayCloseButton = (newValue === "true");
        break;
      case 'clear-previous-message':
        this.clearPreviousMessage = (newValue === "true");
        break;
      case 'animation-css':
        this.animationCss = newValue;
        break;
      default:
      break;
    }
  }

  render() {
    return html`
        <style>
        .snackbar {
          min-width: 21.5rem;
          max-width: 21.5rem;
          min-height: 3rem;
          padding: .5rem 1rem;
          background-color: #363545;
          box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.3);
          border-radius: .125rem;
          align-items: center;
          justify-content: space-between;
          display: flex;
          position: fixed;
          bottom: 1.5rem;
          left: 1.5rem;
          z-index: 99 !important; 
        }
          
        .snackbar label {
          color: #FFFFFF;
          font-size: 0.875rem;
          font-weight: 400; 
        }
        
        @-webkit-keyframes fadeIn {
          0% {
            opacity: 0;
            -webkit-transform: translateY(20px);
          }	15% {
            opacity: 1;
            -webkit-transform: translateY(0);
          }
            85% {
            opacity: 1;
            -webkit-transform: translateY(0);
          }
            100% {
            opacity: 0;
            -webkit-transform: translateY(20px);
          }
        }
        
        @-moz-keyframes fadeIn {
          0% {
            opacity: 0;
            -webkit-transform: translateY(20px);
          }	15% {
            opacity: 1;
            -webkit-transform: translateY(0);
          }
            85% {
            opacity: 1;
            -webkit-transform: translateY(0);
          }
            100% {
            opacity: 0;
            -webkit-transform: translateY(20px);
          }
        }
        
        @-o-keyframes fadeIn {
          0% {
            opacity: 0;
            -webkit-transform: translateY(20px);
          }	15% {
            opacity: 1;
            -webkit-transform: translateY(0);
          }
            85% {
            opacity: 1;
            -webkit-transform: translateY(0);
          }
            100% {
            opacity: 0;
            -webkit-transform: translateY(20px);
          }
        }
        
        @keyframes fadeIn {
          0% {
            opacity: 0;
            -webkit-transform: translateY(20px);
          }	15% {
            opacity: 1;
            -webkit-transform: translateY(0);
          }
            85% {
            opacity: 1;
            -webkit-transform: translateY(0);
          }
            100% {
            opacity: 0;
            -webkit-transform: translateY(20px);
          }
        }
        
        </style>
        ${this.snackBarMessages.length ? html`
          <div class="snackbar-container">
            ${this.snackBarMessages.map((snackBarMessage) => 
              html`<div class="snackbar ${this.animationCss}" style="${this.fetchAnimationCss()}">
              <label> ${snackBarMessage} </label>
            </div>`
            )}
          </div>`: ''}
        `;
  }

  fetchAnimationCss() {
    return `-webkit-animation-name: fadeIn;
    -moz-animation-name: fadeIn;
    -o-animation-name: fadeIn;
    animation-name: fadeIn;

    -webkit-animation-fill-mode:none;
    -moz-animation-fill-mode:none;
    -ms-animation-fill-mode:none;
    -o-animation-fill-mode:none;
    animation-fill-mode:none;
    
    -webkit-animation-duration: ` + this.displayDuration + `ms;
    -moz-animation-duration:` + this.displayDuration + `ms;
    -ms-animation-duration:` + this.displayDuration + `ms;
    -o-animation-duration:` + this.displayDuration + `ms;
    animation-duration:` + this.displayDuration + `ms;

    -webkit-animation-iteration-count:1;
    -moz-animation-iteration-count:1;
    -ms-animation-iteration-count:1;
    -o-animation-iteration-count:1;
    animation-iteration-count:1;

    -webkit-animation-play-state:initial;
    -moz-animation-play-state:initial;
    -ms-animation-play-state:initial;
    -o-animation-play-state:initial;
    animation-play-state: initial;`;
  }

}

console.log("is snack-bar already registered = ", !!customElements.get('snack-bar'));
if(!customElements.get('snack-bar')){
  window.customElements.define('snack-bar', SnackBar);
  console.log("is snack-bar registered successfully = ", !!customElements.get('snack-bar'));
}

export default SnackBar;
window.SnackBar = SnackBar;